export default __webpack_public_path__ + "static/media/gameOver4.754b5773.mp3";